<template>
    <div>
        <v-dialog :value="loading" :hide-overlay="true" :persistent="true" max-width="100">
            <div class="text-center loading">
                <v-progress-circular
                    :size="20"
                    color="primary"
                    indeterminate
                    width="2"
                ></v-progress-circular>
            </div>
        </v-dialog>
        <v-dialog :value="push !== null" @click:outside="close" max-width="990px" scrollable>
            <v-card :class="`card`" v-if="push">
                <v-card-title>
                    <typo name="title-17-bold">{{ push.subject }}</typo>
                    <v-icon @click="close" class="icon">mdi-close</v-icon>
                </v-card-title>
                <v-card-text>
                    <div class="banner">
                        <typo name="body-14-light">Envoyé le {{ sentAt }}</typo>
                        <sep v-if="push.source" name="S" />
                        <typo v-if="push.source" name="body-14-normal"
                            >Source : {{ push.source }}</typo
                        >
                    </div>
                    <div class="bodyWrapper">
                        <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component -->
                        <convention-body v-html="push.body"></convention-body>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import Vue from "vue";
import { Services } from "src/services/Services";
import { EventBus } from "src/bus/eventBus";
import ConventionBody from "src/components/convention/ConventionBody.vue";

export default Vue.extend({
    components: { ConventionBody },
    data() {
        return { loading: false, push: null };
    },
    async mounted() {
        EventBus.$on("push-popin:show", id => {
            this.open(id);
        });
    },
    methods: {
        async open(pushId) {
            this.loading = true;
            try {
                this.push = await Services.api.push.getById(pushId);
            } catch (e) {
                this.close();
            } finally {
                this.loading = false;
            }
        },
        close() {
            this.loading = false;
            this.push = null;
        },
    },
    computed: {
        sentAt() {
            return this.push ? Services.moment(this.push.sentAt).format("LLL") : null;
        },
    },
});
</script>

<style lang="sass" scoped>

.v-card__text
    padding: 0 !important

.v-card__title
    background: $color-background

.icon
    margin-left: auto
    color: $color-main

.loading
    padding: $grid-gutter
    width: 100px
    height: 100px
    display: flex
    align-items: center
    justify-content: center
    background: white

.banner
    padding: $grid-gutter $grid-gutter*2
    background-color: $color-text
    color: white

.bodyWrapper
    padding: $grid-gutter*2
    margin: auto
</style>
